var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "13px",
    viewBox: "0 0 15 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aktualnosci",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aktualnosci---artykul---1-edytor",
    transform: "translate(-402.000000, -775.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dodaj-artykul",
    transform: "translate(233.000000, 369.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(37.000000, 389.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(46.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bullets",
    transform: "translate(86.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.882352941,11.2666667 C1.36966301,11.2666667 1.76470588,11.6546866 1.76470588,12.1333333 C1.76470588,12.6119801 1.36966301,13 0.882352941,13 C0.395042868,13 0,12.6119801 0,12.1333333 C0,11.6546866 0.395042868,11.2666667 0.882352941,11.2666667 Z M14.5820433,11.8824561 L14.5820433,12.8824561 L5.29411765,12.8824561 L5.29411765,11.8824561 L14.5820433,11.8824561 Z M0.882352941,6.06666667 C1.36966301,6.06666667 1.76470588,6.45468655 1.76470588,6.93333333 C1.76470588,7.41198012 1.36966301,7.8 0.882352941,7.8 C0.395042868,7.8 0,7.41198012 0,6.93333333 C0,6.45468655 0.395042868,6.06666667 0.882352941,6.06666667 Z M14.5820433,6.68245614 L14.5820433,7.68245614 L5.29411765,7.68245614 L5.29411765,6.68245614 L14.5820433,6.68245614 Z M0.882352941,2.64973229e-15 C1.36966301,2.64973229e-15 1.76470588,0.388019884 1.76470588,0.866666667 C1.76470588,1.34531345 1.36966301,1.73333333 0.882352941,1.73333333 C0.395042868,1.73333333 0,1.34531345 0,0.866666667 C0,0.388019884 0.395042868,2.64973229e-15 0.882352941,2.64973229e-15 Z M14.5820433,0.615789474 L14.5820433,1.61578947 L5.29411765,1.61578947 L5.29411765,0.615789474 L14.5820433,0.615789474 Z",
    id: "Combined-Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionList);
export default __webpack_public_path__ + "static/media/optionList.c19092fe689a3580498f069513722d94.svg";
export { ForwardRef as ReactComponent };